import { render, staticRenderFns } from "./SelectionForm.vue?vue&type=template&id=6168a662&scoped=true&"
import script from "./SelectionForm.vue?vue&type=script&lang=js&"
export * from "./SelectionForm.vue?vue&type=script&lang=js&"
import style0 from "./SelectionForm.vue?vue&type=style&index=0&id=6168a662&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6168a662",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
